




























import { Component, Prop, Vue } from 'vue-property-decorator';
import { ncpPopup } from '@/utils/commonUtils';

@Component
export default class TrTargetGradeGroup extends Vue {
  @Prop({ required: true })
  private gradesContent: number[];
  @Prop({ required: true })
  private groupsContent: number[];
  @Prop({ required: true })
  private memberGrade: string;
  @Prop({ required: true })
  private memberGroup: string;
  @Prop({default: 'and'})
  private targetType: 'and' | 'or';
  @Prop({  default: null})
  private readonly issueTargetType!: 'MEMBER_NO' | 'GRADE_GROUP';

  private get noTargetLabel() {
    return this.targetType === 'or' ? this.$t('MEMBER_TARGET_NO_SELECT') : this.$t('MEMBER_TARGET_MEMBER_ALL');
  }

  private get noTarget() {
    return (this.gradesContent[0] === -1 && this.groupsContent[0] === -1) || (!this.gradesContent.length && !this.groupsContent.length)
  }

  private get isMemberType() {
    return this.issueTargetType === 'MEMBER_NO';
  }

  private handleOpenPop(tap: string): void {
    const mallNo: any = this.$route.query.mallNo ?? this.$route.query.discountNo;
    if (tap === 'grade') {
      const title: any = this.$t('ACCUMULATION_PAYMENT_LIST_GRADE_POPUP_TITLE');
      ncpPopup(
        `/accumulation/popup/payment/displayGradeInfo?grades=${this.gradesContent.join(',')}&mallNo=${mallNo}`,
        title,
        510,
        300,
      );
    }
    if (tap === 'group') {
      const title: any = this.$t('ACCUMULATION_PAYMENT_LIST_GROUP_POPUP_TITLE');
      ncpPopup(
        `/accumulation/popup/payment/displayGroupInfo?groups=${this.groupsContent.join(',')}&mallNo=${mallNo}`,
        title,
        510,
        300,
      );
    }
  }
}
